// extracted by mini-css-extract-plugin
export var menuItem = "y_t0 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "y_t1 d_Z d_bz d_bP";
export var menuMainLink = "y_t2 d_f0 d_dB";
export var menuLink = "y_t3 d_f0 d_dB";
export var icon = "y_p9 d_bC d_bP";
export var divider = "y_t4 d_bC d_bP";
export var sublinks = "y_t5";
export var link = "y_mC";
export var Link = "y_r6 t_r6 t_rv t_rQ";